export default __webpack_public_path__ + "static/media/exportdata.3334abf6.png";